"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableDataCell = exports.StyledTableHeader = exports.StyledTableRow = exports.StyledTableColumn = exports.StyledTableColumnGroup = exports.StyledTableFoot = exports.StyledTableBody = exports.StyledTableHead = exports.StyledTable = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const tokens_1 = require("../../../styles/tokens");
const TableCellStyles = (0, styled_components_1.css) `
    border: ${tokens_1.BORDERS.normal.silver};
    padding: ${tokens_1.SIZES["1.5"]};
`;
exports.StyledTable = styled_components_1.default.table `
    width: 100%;
    border-collapse: collapse;

    ${tokens_1.TYPOGRAPHY.body.base}

    background-color: ${tokens_1.COLOURS.greyscale.white};
`;
exports.StyledTableHead = styled_components_1.default.thead ``;
exports.StyledTableBody = styled_components_1.default.tbody ``;
exports.StyledTableFoot = styled_components_1.default.tfoot ``;
exports.StyledTableColumnGroup = styled_components_1.default.colgroup ``;
exports.StyledTableColumn = styled_components_1.default.col `
    width: ${({ width }) => width !== null && width !== void 0 ? width : "auto"};
    background-color: ${({ colour }) => {
    if (!colour || colour === "transparent")
        return "transparent";
    if (colour === "greyscale")
        return tokens_1.COLOURS.greyscale.cloud;
    return tokens_1.COLOURS.primary[colour]["5"];
}};
`;
exports.StyledTableRow = styled_components_1.default.tr `
    border-bottom: ${({ isBorderBottom }) => isBorderBottom ? `3px solid ${tokens_1.COLOURS.greyscale.silver}` : "none"};
`;
exports.StyledTableHeader = styled_components_1.default.th `
    ${TableCellStyles}
    ${({ colour }) => {
    if (colour === "greyscale")
        return `background-color: ${tokens_1.COLOURS.greyscale.silver};`;
}};
    text-align: left;
`;
exports.StyledTableDataCell = styled_components_1.default.td `
    ${TableCellStyles}
`;
//# sourceMappingURL=Table.styles.js.map